import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectDestructuringEmpty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectDestructuringEmpty.js";
import _classPrivateFieldGet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet.js";
import _classPrivateFieldSet from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classPrivateFieldSet.js";
var _client, _currentQuery, _currentQueryInitialState, _currentResult, _currentResultState, _currentResultOptions, _currentThenable, _selectError, _selectFn, _selectResult, _lastQueryWithDefinedData, _staleTimeoutId, _refetchIntervalId, _currentRefetchInterval, _trackedProps, _executeFetch, _updateStaleTimeout, _computeRefetchInterval, _updateRefetchInterval, _updateTimers, _clearStaleTimeout, _clearRefetchInterval, _updateQuery, _notify;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
// src/queryObserver.ts
import { focusManager } from "./focusManager.js";
import { notifyManager } from "./notifyManager.js";
import { fetchState } from "./query.js";
import { Subscribable } from "./subscribable.js";
import { pendingThenable } from "./thenable.js";
import { isServer, isValidTimeout, noop, replaceData, resolveEnabled, resolveStaleTime, shallowEqualObjects, timeUntilStale } from "./utils.js";
var QueryObserver = (_client = /*#__PURE__*/new WeakMap(), _currentQuery = /*#__PURE__*/new WeakMap(), _currentQueryInitialState = /*#__PURE__*/new WeakMap(), _currentResult = /*#__PURE__*/new WeakMap(), _currentResultState = /*#__PURE__*/new WeakMap(), _currentResultOptions = /*#__PURE__*/new WeakMap(), _currentThenable = /*#__PURE__*/new WeakMap(), _selectError = /*#__PURE__*/new WeakMap(), _selectFn = /*#__PURE__*/new WeakMap(), _selectResult = /*#__PURE__*/new WeakMap(), _lastQueryWithDefinedData = /*#__PURE__*/new WeakMap(), _staleTimeoutId = /*#__PURE__*/new WeakMap(), _refetchIntervalId = /*#__PURE__*/new WeakMap(), _currentRefetchInterval = /*#__PURE__*/new WeakMap(), _trackedProps = /*#__PURE__*/new WeakMap(), _executeFetch = /*#__PURE__*/new WeakSet(), _updateStaleTimeout = /*#__PURE__*/new WeakSet(), _computeRefetchInterval = /*#__PURE__*/new WeakSet(), _updateRefetchInterval = /*#__PURE__*/new WeakSet(), _updateTimers = /*#__PURE__*/new WeakSet(), _clearStaleTimeout = /*#__PURE__*/new WeakSet(), _clearRefetchInterval = /*#__PURE__*/new WeakSet(), _updateQuery = /*#__PURE__*/new WeakSet(), _notify = /*#__PURE__*/new WeakSet(), class QueryObserver extends Subscribable {
  constructor(client, options) {
    super();
    _classPrivateMethodInitSpec(this, _notify);
    _classPrivateMethodInitSpec(this, _updateQuery);
    _classPrivateMethodInitSpec(this, _clearRefetchInterval);
    _classPrivateMethodInitSpec(this, _clearStaleTimeout);
    _classPrivateMethodInitSpec(this, _updateTimers);
    _classPrivateMethodInitSpec(this, _updateRefetchInterval);
    _classPrivateMethodInitSpec(this, _computeRefetchInterval);
    _classPrivateMethodInitSpec(this, _updateStaleTimeout);
    _classPrivateMethodInitSpec(this, _executeFetch);
    _classPrivateFieldInitSpec(this, _client, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _currentQuery, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _currentQueryInitialState, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _currentResult, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _currentResultState, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _currentResultOptions, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _currentThenable, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _selectError, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _selectFn, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _selectResult, {
      writable: true,
      value: void 0
    });
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    _classPrivateFieldInitSpec(this, _lastQueryWithDefinedData, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _staleTimeoutId, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _refetchIntervalId, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _currentRefetchInterval, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _trackedProps, {
      writable: true,
      value: /* @__PURE__ */new Set()
    });
    this.options = options;
    _classPrivateFieldSet(this, _client, client);
    _classPrivateFieldSet(this, _selectError, null);
    _classPrivateFieldSet(this, _currentThenable, pendingThenable());
    if (!this.options.experimental_prefetchInRender) {
      _classPrivateFieldGet(this, _currentThenable).reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
    }
    this.bindMethods();
    this.setOptions(options);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    if (this.listeners.size === 1) {
      _classPrivateFieldGet(this, _currentQuery).addObserver(this);
      if (shouldFetchOnMount(_classPrivateFieldGet(this, _currentQuery), this.options)) {
        _classPrivateMethodGet(this, _executeFetch, _executeFetch2).call(this);
      } else {
        this.updateResult();
      }
      _classPrivateMethodGet(this, _updateTimers, _updateTimers2).call(this);
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      this.destroy();
    }
  }
  shouldFetchOnReconnect() {
    return shouldFetchOn(_classPrivateFieldGet(this, _currentQuery), this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return shouldFetchOn(_classPrivateFieldGet(this, _currentQuery), this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = /* @__PURE__ */new Set();
    _classPrivateMethodGet(this, _clearStaleTimeout, _clearStaleTimeout2).call(this);
    _classPrivateMethodGet(this, _clearRefetchInterval, _clearRefetchInterval2).call(this);
    _classPrivateFieldGet(this, _currentQuery).removeObserver(this);
  }
  setOptions(options) {
    const prevOptions = this.options;
    const prevQuery = _classPrivateFieldGet(this, _currentQuery);
    this.options = _classPrivateFieldGet(this, _client).defaultQueryOptions(options);
    if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof resolveEnabled(this.options.enabled, _classPrivateFieldGet(this, _currentQuery)) !== "boolean") {
      throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
    }
    _classPrivateMethodGet(this, _updateQuery, _updateQuery2).call(this);
    _classPrivateFieldGet(this, _currentQuery).setOptions(this.options);
    if (prevOptions._defaulted && !shallowEqualObjects(this.options, prevOptions)) {
      _classPrivateFieldGet(this, _client).getQueryCache().notify({
        type: "observerOptionsUpdated",
        query: _classPrivateFieldGet(this, _currentQuery),
        observer: this
      });
    }
    const mounted = this.hasListeners();
    if (mounted && shouldFetchOptionally(_classPrivateFieldGet(this, _currentQuery), prevQuery, this.options, prevOptions)) {
      _classPrivateMethodGet(this, _executeFetch, _executeFetch2).call(this);
    }
    this.updateResult();
    if (mounted && (_classPrivateFieldGet(this, _currentQuery) !== prevQuery || resolveEnabled(this.options.enabled, _classPrivateFieldGet(this, _currentQuery)) !== resolveEnabled(prevOptions.enabled, _classPrivateFieldGet(this, _currentQuery)) || resolveStaleTime(this.options.staleTime, _classPrivateFieldGet(this, _currentQuery)) !== resolveStaleTime(prevOptions.staleTime, _classPrivateFieldGet(this, _currentQuery)))) {
      _classPrivateMethodGet(this, _updateStaleTimeout, _updateStaleTimeout2).call(this);
    }
    const nextRefetchInterval = _classPrivateMethodGet(this, _computeRefetchInterval, _computeRefetchInterval2).call(this);
    if (mounted && (_classPrivateFieldGet(this, _currentQuery) !== prevQuery || resolveEnabled(this.options.enabled, _classPrivateFieldGet(this, _currentQuery)) !== resolveEnabled(prevOptions.enabled, _classPrivateFieldGet(this, _currentQuery)) || nextRefetchInterval !== _classPrivateFieldGet(this, _currentRefetchInterval))) {
      _classPrivateMethodGet(this, _updateRefetchInterval, _updateRefetchInterval2).call(this, nextRefetchInterval);
    }
  }
  getOptimisticResult(options) {
    const query = _classPrivateFieldGet(this, _client).getQueryCache().build(_classPrivateFieldGet(this, _client), options);
    const result = this.createResult(query, options);
    if (shouldAssignObserverCurrentProperties(this, result)) {
      _classPrivateFieldSet(this, _currentResult, result);
      _classPrivateFieldSet(this, _currentResultOptions, this.options);
      _classPrivateFieldSet(this, _currentResultState, _classPrivateFieldGet(this, _currentQuery).state);
    }
    return result;
  }
  getCurrentResult() {
    return _classPrivateFieldGet(this, _currentResult);
  }
  trackResult(result, onPropTracked) {
    const trackedResult = {};
    Object.keys(result).forEach(key => {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: () => {
          this.trackProp(key);
          onPropTracked === null || onPropTracked === void 0 || onPropTracked(key);
          return result[key];
        }
      });
    });
    return trackedResult;
  }
  trackProp(key) {
    _classPrivateFieldGet(this, _trackedProps).add(key);
  }
  getCurrentQuery() {
    return _classPrivateFieldGet(this, _currentQuery);
  }
  refetch() {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      options = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
    return this.fetch(_objectSpread({}, options));
  }
  fetchOptimistic(options) {
    const defaultedOptions = _classPrivateFieldGet(this, _client).defaultQueryOptions(options);
    const query = _classPrivateFieldGet(this, _client).getQueryCache().build(_classPrivateFieldGet(this, _client), defaultedOptions);
    return query.fetch().then(() => this.createResult(query, defaultedOptions));
  }
  fetch(fetchOptions) {
    var _fetchOptions$cancelR;
    return _classPrivateMethodGet(this, _executeFetch, _executeFetch2).call(this, _objectSpread(_objectSpread({}, fetchOptions), {}, {
      cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) !== null && _fetchOptions$cancelR !== void 0 ? _fetchOptions$cancelR : true
    })).then(() => {
      this.updateResult();
      return _classPrivateFieldGet(this, _currentResult);
    });
  }
  createResult(query, options) {
    const prevQuery = _classPrivateFieldGet(this, _currentQuery);
    const prevOptions = this.options;
    const prevResult = _classPrivateFieldGet(this, _currentResult);
    const prevResultState = _classPrivateFieldGet(this, _currentResultState);
    const prevResultOptions = _classPrivateFieldGet(this, _currentResultOptions);
    const queryChange = query !== prevQuery;
    const queryInitialState = queryChange ? query.state : _classPrivateFieldGet(this, _currentQueryInitialState);
    const {
      state
    } = query;
    let newState = _objectSpread({}, state);
    let isPlaceholderData = false;
    let data;
    if (options._optimisticResults) {
      const mounted = this.hasListeners();
      const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
      if (fetchOnMount || fetchOptionally) {
        newState = _objectSpread(_objectSpread({}, newState), fetchState(state.data, query.options));
      }
      if (options._optimisticResults === "isRestoring") {
        newState.fetchStatus = "idle";
      }
    }
    let {
      error,
      errorUpdatedAt,
      status
    } = newState;
    if (options.select && newState.data !== void 0) {
      if (prevResult && newState.data === (prevResultState === null || prevResultState === void 0 ? void 0 : prevResultState.data) && options.select === _classPrivateFieldGet(this, _selectFn)) {
        data = _classPrivateFieldGet(this, _selectResult);
      } else {
        try {
          _classPrivateFieldSet(this, _selectFn, options.select);
          data = options.select(newState.data);
          data = replaceData(prevResult === null || prevResult === void 0 ? void 0 : prevResult.data, data, options);
          _classPrivateFieldSet(this, _selectResult, data);
          _classPrivateFieldSet(this, _selectError, null);
        } catch (selectError) {
          _classPrivateFieldSet(this, _selectError, selectError);
        }
      }
    } else {
      data = newState.data;
    }
    if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
      let placeholderData;
      if (prevResult !== null && prevResult !== void 0 && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions === null || prevResultOptions === void 0 ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        var _classPrivateFieldGet2;
        placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_classPrivateFieldGet2 = _classPrivateFieldGet(this, _lastQueryWithDefinedData)) === null || _classPrivateFieldGet2 === void 0 ? void 0 : _classPrivateFieldGet2.state.data, _classPrivateFieldGet(this, _lastQueryWithDefinedData)) : options.placeholderData;
        if (options.select && placeholderData !== void 0) {
          try {
            placeholderData = options.select(placeholderData);
            _classPrivateFieldSet(this, _selectError, null);
          } catch (selectError) {
            _classPrivateFieldSet(this, _selectError, selectError);
          }
        }
      }
      if (placeholderData !== void 0) {
        status = "success";
        data = replaceData(prevResult === null || prevResult === void 0 ? void 0 : prevResult.data, placeholderData, options);
        isPlaceholderData = true;
      }
    }
    if (_classPrivateFieldGet(this, _selectError)) {
      error = _classPrivateFieldGet(this, _selectError);
      data = _classPrivateFieldGet(this, _selectResult);
      errorUpdatedAt = Date.now();
      status = "error";
    }
    const isFetching = newState.fetchStatus === "fetching";
    const isPending = status === "pending";
    const isError = status === "error";
    const isLoading = isPending && isFetching;
    const hasData = data !== void 0;
    const result = {
      status,
      fetchStatus: newState.fetchStatus,
      isPending,
      isSuccess: status === "success",
      isError,
      isInitialLoading: isLoading,
      isLoading,
      data,
      dataUpdatedAt: newState.dataUpdatedAt,
      error,
      errorUpdatedAt,
      failureCount: newState.fetchFailureCount,
      failureReason: newState.fetchFailureReason,
      errorUpdateCount: newState.errorUpdateCount,
      isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
      isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching,
      isRefetching: isFetching && !isPending,
      isLoadingError: isError && !hasData,
      isPaused: newState.fetchStatus === "paused",
      isPlaceholderData,
      isRefetchError: isError && hasData,
      isStale: isStale(query, options),
      refetch: this.refetch,
      promise: _classPrivateFieldGet(this, _currentThenable)
    };
    const nextResult = result;
    if (this.options.experimental_prefetchInRender) {
      const finalizeThenableIfPossible = thenable => {
        if (nextResult.status === "error") {
          thenable.reject(nextResult.error);
        } else if (nextResult.data !== void 0) {
          thenable.resolve(nextResult.data);
        }
      };
      const recreateThenable = () => {
        const pending = _classPrivateFieldSet(this, _currentThenable, nextResult.promise = pendingThenable());
        finalizeThenableIfPossible(pending);
      };
      const prevThenable = _classPrivateFieldGet(this, _currentThenable);
      switch (prevThenable.status) {
        case "pending":
          if (query.queryHash === prevQuery.queryHash) {
            finalizeThenableIfPossible(prevThenable);
          }
          break;
        case "fulfilled":
          if (nextResult.status === "error" || nextResult.data !== prevThenable.value) {
            recreateThenable();
          }
          break;
        case "rejected":
          if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) {
            recreateThenable();
          }
          break;
      }
    }
    return nextResult;
  }
  updateResult() {
    const prevResult = _classPrivateFieldGet(this, _currentResult);
    const nextResult = this.createResult(_classPrivateFieldGet(this, _currentQuery), this.options);
    _classPrivateFieldSet(this, _currentResultState, _classPrivateFieldGet(this, _currentQuery).state);
    _classPrivateFieldSet(this, _currentResultOptions, this.options);
    if (_classPrivateFieldGet(this, _currentResultState).data !== void 0) {
      _classPrivateFieldSet(this, _lastQueryWithDefinedData, _classPrivateFieldGet(this, _currentQuery));
    }
    if (shallowEqualObjects(nextResult, prevResult)) {
      return;
    }
    _classPrivateFieldSet(this, _currentResult, nextResult);
    const shouldNotifyListeners = () => {
      if (!prevResult) {
        return true;
      }
      const {
        notifyOnChangeProps
      } = this.options;
      const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
      if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !_classPrivateFieldGet(this, _trackedProps).size) {
        return true;
      }
      const includedProps = new Set(notifyOnChangePropsValue !== null && notifyOnChangePropsValue !== void 0 ? notifyOnChangePropsValue : _classPrivateFieldGet(this, _trackedProps));
      if (this.options.throwOnError) {
        includedProps.add("error");
      }
      return Object.keys(_classPrivateFieldGet(this, _currentResult)).some(key => {
        const typedKey = key;
        const changed = _classPrivateFieldGet(this, _currentResult)[typedKey] !== prevResult[typedKey];
        return changed && includedProps.has(typedKey);
      });
    };
    _classPrivateMethodGet(this, _notify, _notify2).call(this, {
      listeners: shouldNotifyListeners()
    });
  }
  onQueryUpdate() {
    this.updateResult();
    if (this.hasListeners()) {
      _classPrivateMethodGet(this, _updateTimers, _updateTimers2).call(this);
    }
  }
});
function _executeFetch2(fetchOptions) {
  _classPrivateMethodGet(this, _updateQuery, _updateQuery2).call(this);
  let promise = _classPrivateFieldGet(this, _currentQuery).fetch(this.options, fetchOptions);
  if (!(fetchOptions !== null && fetchOptions !== void 0 && fetchOptions.throwOnError)) {
    promise = promise.catch(noop);
  }
  return promise;
}
function _updateStaleTimeout2() {
  _classPrivateMethodGet(this, _clearStaleTimeout, _clearStaleTimeout2).call(this);
  const staleTime = resolveStaleTime(this.options.staleTime, _classPrivateFieldGet(this, _currentQuery));
  if (isServer || _classPrivateFieldGet(this, _currentResult).isStale || !isValidTimeout(staleTime)) {
    return;
  }
  const time = timeUntilStale(_classPrivateFieldGet(this, _currentResult).dataUpdatedAt, staleTime);
  const timeout = time + 1;
  _classPrivateFieldSet(this, _staleTimeoutId, setTimeout(() => {
    if (!_classPrivateFieldGet(this, _currentResult).isStale) {
      this.updateResult();
    }
  }, timeout));
}
function _computeRefetchInterval2() {
  var _ref2;
  return (_ref2 = typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(_classPrivateFieldGet(this, _currentQuery)) : this.options.refetchInterval) !== null && _ref2 !== void 0 ? _ref2 : false;
}
function _updateRefetchInterval2(nextInterval) {
  _classPrivateMethodGet(this, _clearRefetchInterval, _clearRefetchInterval2).call(this);
  _classPrivateFieldSet(this, _currentRefetchInterval, nextInterval);
  if (isServer || resolveEnabled(this.options.enabled, _classPrivateFieldGet(this, _currentQuery)) === false || !isValidTimeout(_classPrivateFieldGet(this, _currentRefetchInterval)) || _classPrivateFieldGet(this, _currentRefetchInterval) === 0) {
    return;
  }
  _classPrivateFieldSet(this, _refetchIntervalId, setInterval(() => {
    if (this.options.refetchIntervalInBackground || focusManager.isFocused()) {
      _classPrivateMethodGet(this, _executeFetch, _executeFetch2).call(this);
    }
  }, _classPrivateFieldGet(this, _currentRefetchInterval)));
}
function _updateTimers2() {
  _classPrivateMethodGet(this, _updateStaleTimeout, _updateStaleTimeout2).call(this);
  _classPrivateMethodGet(this, _updateRefetchInterval, _updateRefetchInterval2).call(this, _classPrivateMethodGet(this, _computeRefetchInterval, _computeRefetchInterval2).call(this));
}
function _clearStaleTimeout2() {
  if (_classPrivateFieldGet(this, _staleTimeoutId)) {
    clearTimeout(_classPrivateFieldGet(this, _staleTimeoutId));
    _classPrivateFieldSet(this, _staleTimeoutId, void 0);
  }
}
function _clearRefetchInterval2() {
  if (_classPrivateFieldGet(this, _refetchIntervalId)) {
    clearInterval(_classPrivateFieldGet(this, _refetchIntervalId));
    _classPrivateFieldSet(this, _refetchIntervalId, void 0);
  }
}
function _updateQuery2() {
  const query = _classPrivateFieldGet(this, _client).getQueryCache().build(_classPrivateFieldGet(this, _client), this.options);
  if (query === _classPrivateFieldGet(this, _currentQuery)) {
    return;
  }
  const prevQuery = _classPrivateFieldGet(this, _currentQuery);
  _classPrivateFieldSet(this, _currentQuery, query);
  _classPrivateFieldSet(this, _currentQueryInitialState, query.state);
  if (this.hasListeners()) {
    prevQuery === null || prevQuery === void 0 || prevQuery.removeObserver(this);
    query.addObserver(this);
  }
}
function _notify2(notifyOptions) {
  notifyManager.batch(() => {
    if (notifyOptions.listeners) {
      this.listeners.forEach(listener => {
        listener(_classPrivateFieldGet(this, _currentResult));
      });
    }
    _classPrivateFieldGet(this, _client).getQueryCache().notify({
      query: _classPrivateFieldGet(this, _currentQuery),
      type: "observerResultsUpdated"
    });
  });
}
function shouldLoadOnMount(query, options) {
  return resolveEnabled(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.data !== void 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
  if (resolveEnabled(options.enabled, query) !== false) {
    const value = typeof field === "function" ? field(query) : field;
    return value === "always" || value !== false && isStale(query, options);
  }
  return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return (query !== prevQuery || resolveEnabled(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && isStale(query, options);
}
function isStale(query, options) {
  return resolveEnabled(options.enabled, query) !== false && query.isStaleByTime(resolveStaleTime(options.staleTime, query));
}
function shouldAssignObserverCurrentProperties(observer, optimisticResult) {
  if (!shallowEqualObjects(observer.getCurrentResult(), optimisticResult)) {
    return true;
  }
  return false;
}
export { QueryObserver };